import { buildModelManager } from "../builder.js";
const DefaultKlaviyoAudienceMembershipSelection = {
  __typename: true,
  id: true,
  createdAt: true,
  fetchStatus: true,
  fetchedAt: true,
  identityHash: true,
  lists: true,
  shopId: true,
  updatedAt: true
};
const modelApiIdentifier = "klaviyoAudienceMembership";
const pluralModelApiIdentifier = "klaviyoAudienceMemberships";
;
;
;
;
;
;
;
;
;
const operations = [
  {
    type: "findOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultKlaviyoAudienceMembershipSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultKlaviyoAudienceMembershipSelection,
    namespace: null
  },
  {
    type: "findMany",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultKlaviyoAudienceMembershipSelection,
    namespace: null
  },
  {
    type: "findFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultKlaviyoAudienceMembershipSelection,
    namespace: null
  },
  {
    type: "maybeFindFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultKlaviyoAudienceMembershipSelection,
    namespace: null
  },
  {
    type: "findOne",
    operationName: pluralModelApiIdentifier,
    functionName: "findById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultKlaviyoAudienceMembershipSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: pluralModelApiIdentifier,
    functionName: "maybeFindById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultKlaviyoAudienceMembershipSelection,
    namespace: null
  },
  {
    type: "action",
    operationName: "createKlaviyoAudienceMembership",
    operationReturnType: "CreateKlaviyoAudienceMembership",
    functionName: "create",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: false,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      klaviyoAudienceMembership: { required: false, type: "CreateKlaviyoAudienceMembershipInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultKlaviyoAudienceMembershipSelection
  },
  {
    type: "action",
    operationName: "bulkCreateKlaviyoAudienceMemberships",
    functionName: "bulkCreate",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: false,
    singleActionFunctionName: "create",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: {
        required: true,
        type: "[BulkCreateKlaviyoAudienceMembershipsInput!]"
      }
    },
    paramOnlyVariables: [],
    defaultSelection: DefaultKlaviyoAudienceMembershipSelection
  },
  {
    type: "action",
    operationName: "updateKlaviyoAudienceMembership",
    operationReturnType: "UpdateKlaviyoAudienceMembership",
    functionName: "update",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: true,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      id: { required: true, type: "GadgetID" },
      klaviyoAudienceMembership: { required: false, type: "UpdateKlaviyoAudienceMembershipInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultKlaviyoAudienceMembershipSelection
  },
  {
    type: "action",
    operationName: "bulkUpdateKlaviyoAudienceMemberships",
    functionName: "bulkUpdate",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: true,
    singleActionFunctionName: "update",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: {
        required: true,
        type: "[BulkUpdateKlaviyoAudienceMembershipsInput!]"
      }
    },
    paramOnlyVariables: [],
    defaultSelection: DefaultKlaviyoAudienceMembershipSelection
  },
  {
    type: "action",
    operationName: "deleteKlaviyoAudienceMembership",
    operationReturnType: "DeleteKlaviyoAudienceMembership",
    functionName: "delete",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: true,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: true,
    variables: { id: { required: true, type: "GadgetID" } },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: false,
    hasCreateOrUpdateEffect: false,
    defaultSelection: null
  },
  {
    type: "action",
    operationName: "bulkDeleteKlaviyoAudienceMemberships",
    functionName: "bulkDelete",
    isBulk: true,
    isDeleter: true,
    hasReturnType: false,
    acceptsModelInput: false,
    operatesWithRecordIdentity: true,
    singleActionFunctionName: "delete",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: { ids: { required: true, type: "[GadgetID!]" } },
    paramOnlyVariables: [],
    defaultSelection: null
  },
  {
    type: "action",
    operationName: "upsertKlaviyoAudienceMembership",
    operationReturnType: "UpsertKlaviyoAudienceMembership",
    functionName: "upsert",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: false,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      on: { required: false, type: "[String!]" },
      klaviyoAudienceMembership: { required: false, type: "UpsertKlaviyoAudienceMembershipInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: ["on"],
    hasReturnType: {
      "... on CreateKlaviyoAudienceMembershipResult": { hasReturnType: false },
      "... on UpdateKlaviyoAudienceMembershipResult": { hasReturnType: false }
    },
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultKlaviyoAudienceMembershipSelection
  },
  {
    type: "action",
    operationName: "bulkUpsertKlaviyoAudienceMemberships",
    functionName: "bulkUpsert",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: false,
    singleActionFunctionName: "upsert",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: {
        required: true,
        type: "[BulkUpsertKlaviyoAudienceMembershipsInput!]"
      }
    },
    paramOnlyVariables: ["on"],
    defaultSelection: DefaultKlaviyoAudienceMembershipSelection
  },
  {
    type: "computedView",
    operationName: "view",
    functionName: "view",
    gqlFieldName: "klaviyoAudienceMembershipGellyView",
    namespace: null,
    variables: {
      query: { type: "String", required: true },
      args: { type: "JSONObject" }
    }
  }
];
const KlaviyoAudienceMembershipManager = buildModelManager(
  modelApiIdentifier,
  pluralModelApiIdentifier,
  DefaultKlaviyoAudienceMembershipSelection,
  operations
);
export {
  DefaultKlaviyoAudienceMembershipSelection,
  KlaviyoAudienceMembershipManager
};
//# sourceMappingURL=KlaviyoAudienceMembership.js.map
